<template>
  <div v-show="value" style="position:fixed;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:row;align-items:center;justify-content:center;background-color:rgba(0,0,0,0.5);z-index:2000">
    <div style="background-color:white;position:relative">
      <div style="position:absolute;top:10px;right:10px;cursor:pointer"><i class="el-icon-close" @click="close"></i></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',

  props: [ 'value' ],

  methods: {
    close () {
      this.$emit('input', false)
    }
  }
}
</script>
